<template>
  <div>
    <!-- Table Container Card -->
    <div class="row">
      <div class="col-sm-8" v-if="$can('import_create')">
        <b-card no-body class="mb-0 p-1">
          <b-form autocomplete="off" id="import-form">
            <div class="d-flex justify-content-between">
              <p class="collapse-title h5">Import</p>
              <div>
                <b-button
                  type="submit"
                  @click.prevent="formSubmitted"
                  variant="primary"
                  :disabled="isBusy"
                >
                  <b-spinner v-if="isBusy" small class="mr-50"></b-spinner>
                  Import
                </b-button>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <label for="import" class="d-flex"
                  >Upload File
                  <small class="ml-1 text-warning flex items-center small">
                    <feather-icon icon="AlertCircleIcon" class="mr-25" />
                    Allowed formats
                    <b> (.xlsx, .xls, .csv)</b>
                  </small>
                </label>
                <b-form-file
                  id="import"
                  v-model="file"
                  placeholder="Choose a file or drop it here..."
                  accept=".csv,.xlsx,.xls"
                  drop-placeholder="Drop file here..."
                />
              </div>
              <div class="col-6">
                <label for="import">Import Type</label>
                <v-select
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  v-model="moduleFilter"
                  item-text="moduleFilter"
                  :options="moduleOptions"
                  :clearable="false"
                  class="w-100"
                  placeholder="Select Module.."
                />
              </div>
            </div>
          </b-form>
        </b-card>
      </div>
      <div class="col-sm-4">
        <b-card no-body class="mb-0 p-1">
          <b-form autocomplete="off" id="import-form">
            <div class="d-flex justify-content-between">
              <p class="collapse-title h5">Sample Download</p>
              <div>
                <b-button
                  type="submit"
                  :disabled="sampleModuleFilter == '' ? true : false"
                  @click.prevent="
                    openWindow(
                      sampleLinks[sampleModuleFilter.replace(/\s+/g, '')]
                    )
                  "
                  variant="primary"
                  >Download</b-button
                >
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <label for="import">Sample Import</label>
                <v-select
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  v-model="sampleModuleFilter"
                  item-text="moduleFilter"
                  :options="moduleOptions"
                  :clearable="false"
                  class="w-100"
                  placeholder="Select Module.."
                />
              </div>
            </div>
          </b-form>
        </b-card>
      </div>
    </div>
    <b-card no-body class="mb-0 mt-2">
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <b-form-checkbox
              v-if="importsMetaData.length && $can('import_delete') && false"
              class="mr-2"
              v-model="isDeleteMultipleCandChecked"
            >
            </b-form-checkbox>
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              :searchable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="6">
            <div
              v-if="selectedImports.length == 0"
              class="d-flex align-items-center justify-content-end"
            >
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <feather-icon icon="SearchIcon" />
                </b-input-group-prepend>
                <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  placeholder="Search Name"
                />
              </b-input-group>

              <!-- <b-button
                v-if="$can('import_create')"
                variant="primary"
                :to="{ name: 'add-import' }"
              >
                <span class="text-nowrap">Add Import</span>
              </b-button> -->
            </div>
            <b-button
              v-else-if="$can('import_delete')"
              class="float-right"
              variant="danger"
              :disabled="importsDeleteCount == 0"
              @click="confirmDeleteMultipleRecords"
            >
              <span class="text-nowrap"
                >Delete {{ importsDeleteCount }} Import</span
              >
            </b-button>
          </b-col>
        </b-row>
      </div>

      <b-form-checkbox-group
        id="checkbox-group"
        v-model="selectedImports"
        name="selectedImports"
      >
        <b-table
          ref="refUserListTable"
          class="position-relative"
          :items="fetchImportList"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="No matching records found"
          :sort-desc.sync="isSortDirDesc"
        >
          <template #cell(select)="data">
            <div class="text-nowrap text-center">
              <b-form-checkbox :value="data.item.hashid"> </b-form-checkbox>
            </div>
          </template>
          <!-- Column: User -->
          <template #cell(title)="data">
            <b-media vertical-align="center">
              <b-link
                v-if="$can('import_show')"
                :to="{
                  name: 'view-import',
                  params: { id: data.item.hashid },
                }"
                class="font-weight-bold d-inline-block text-nowrap"
                v-b-tooltip.hover.v-default
                :title="data.item.title"
              >
                {{ data.item.title | str_limit(15) }}
              </b-link>
              <span
                v-else
                v-b-tooltip.hover.topright.v-primary
                :title="data.item.title"
              >
                {{ data.item.title | str_limit(15) }}
              </span>
            </b-media>
          </template>

          <!--Column: Status -->
          <template #cell(status)="data">
            <b-badge
              pill
              :variant="`light-${resolveUserStatusVariant(data.item.status)}`"
              class="text-capitalize"
            >
              {{ data.item.status == "1" ? "Active" : "In Active" }}
            </b-badge>
          </template>

          <template #cell(completed)="data">
            <b-progress
              v-if="data.item.completed != 1"
              :value="data.item.progress"
              variant="success"
              striped
              animated
            ></b-progress>
            <b-badge v-if="data.item.completed == 1" pill variant="success">
              <feather-icon
                icon="CheckCircleIcon"
                size="24"
                class="align-middle"
              />
              Completed
            </b-badge>
            <b-badge v-if="data.item.completed == 2" pill variant="warning">
              <feather-icon
                icon="CheckCircleIcon"
                size="24"
                class="align-middle"
              />
              Partially Completed
            </b-badge>
          </template>

          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <b-dropdown
              variant="link"
              size="sm"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>

              <!-- <b-dropdown-item
                class="btn-sm p-0"
                @click="editRecord(data)"
                v-if="$can('import_edit')"
              >
                <feather-icon icon="EditIcon" size="13" class="mr-50" />
                <span>Edit</span>
              </b-dropdown-item>

              <b-dropdown-item
                class="btn-sm p-0"
                @click="viewRecord(data)"
                v-if="$can('import_show')"
              >
                <feather-icon icon="EyeIcon" size="13" class="mr-50" />
                <span>View</span>
              </b-dropdown-item> -->

              <b-dropdown-item
                v-if="data.item.completed == 2"
                v-for="(file, index) in data.item.failure_file_links"
                :key="index"
                class="btn-sm p-0"
                @click.stop.prevent="openWindow(file.link)"
              >
                <feather-icon icon="DownloadIcon" size="13" class="mr-50" />
                <span>Failure {{ file.Name.replace(/_/g, ' ') }} Sheet</span>
              </b-dropdown-item>

              <b-dropdown-item
                class="btn-sm p-0"
                @click="confirmDeleteRecord(data)"
                v-if="$can('import_delete')"
              >
                <feather-icon icon="TrashIcon" size="13" class="mr-50" />
                <span>Delete</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
      </b-form-checkbox-group>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="
              d-flex
              align-items-center
              justify-content-center justify-content-sm-start
            "
          >
            <span class="text-muted"
              >Showing {{ dataMeta.from }} to {{ dataMeta.to }} of
              {{ dataMeta.of }} entries</span
            >
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="
              d-flex
              align-items-center
              justify-content-center justify-content-sm-end
            "
          >
            <b-pagination
              v-if="selectedImports.length == 0"
              v-model="currentPage"
              :total-rows="totalImportList"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
            <b-button
              v-else-if="$can('import_delete')"
              class="float-right"
              variant="danger"
              :disabled="importsDeleteCount == 0"
              @click="confirmDeleteMultipleRecords"
            >
              <span class="text-nowrap"
                >Delete {{ importsDeleteCount }} Import</span
              >
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BButton,
  BCard,
  BCol,
  BFormInput,
  BLink,
  BMedia,
  BPagination,
  BRow,
  BTable,
  VBTooltip,
  BFormCheckbox,
  BFormCheckboxGroup,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { onUnmounted, watch, ref } from "@vue/composition-api";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import importStoreModule from "../importStoreModule";
import useImportList from "./useImportList";
import ImportListFilters from "./ImportListFilters.vue";

export default {
  components: {
    ImportListFilters,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BLink,
    BPagination,
    AppCollapse,
    AppCollapseItem,
    vSelect,
    ToastificationContent,
    BFormCheckbox,
    BFormCheckboxGroup,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  setup() {
    const REFERRAL_APP_STORE_MODULE_NAME = "app-imports";
    const isDeleteMultipleCandChecked = ref(false);
    const selectedImports = ref([]);
    const importsDeleteCount = ref(0);

    // Register module
    if (!store.hasModule(REFERRAL_APP_STORE_MODULE_NAME)) {
      store.registerModule(REFERRAL_APP_STORE_MODULE_NAME, importStoreModule);
    }

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(REFERRAL_APP_STORE_MODULE_NAME))
        store.unregisterModule(REFERRAL_APP_STORE_MODULE_NAME);
    });

    const statusOptions = [
      { label: "In Progress", code: 0 },
      { label: "Selected", code: 1 },
      { label: "Rejected", code: 2 },
    ];
    const {
      fetchImportList,
      tableColumns,
      perPage,
      currentPage,
      totalImportList,
      importsMetaData,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,
      statusFilter,
      filterByImportUrgencyStatus,
      filterByImportType,
      resolveUserStatusVariant,
      importStatusOption,
    } = useImportList();

    watch(isDeleteMultipleCandChecked, (val) => {
      selectedImports.value = [];
      if (val) {
        importsMetaData.value.forEach((item) => {
          selectedImports.value.push(item.hashid);
        });
      }
    });

    watch(selectedImports, (val) => {
      importsDeleteCount.value = val.length;
    });

    return {
      // Sidebar
      fetchImportList,
      tableColumns,
      perPage,
      currentPage,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,
      totalImportList,
      // Extra Filters
      statusOptions,
      statusFilter,
      filterByImportUrgencyStatus,
      filterByImportType,
      selectedImports,
      importsDeleteCount,
      isDeleteMultipleCandChecked,
      resolveUserStatusVariant,
      importStatusOption,
      importsMetaData,
    };
  },
  data() {
    return {
      isBusy: false,
      moduleOptions: [
        "Shifts",
        "Employee",
        "Candidate",
        "Leave Balance",
        "Holiday Calendar",
        "Company Tree",
        "Job Opening",
        "Karma Catalog",
      ],
      moduleFilter: "",
      sampleModuleFilter: "",
      sampleLink: "",
      file: [],
      sampleLinks: {
        Shifts: process.env.VUE_APP_S3_ASSET_URL + "/import-sample/shifts.csv",
        Employee: process.env.VUE_APP_S3_ASSET_URL + "/import-sample/employee.csv",
        Candidate:
          process.env.VUE_APP_S3_ASSET_URL + "/import-sample/candidates.csv",
        LeaveBalance:
          process.env.VUE_APP_S3_ASSET_URL + "/import-sample/leave_balance.csv",
        HolidayCalendar:
          process.env.VUE_APP_S3_ASSET_URL + "/import-sample/holidays.csv",
        CompanyTree:
          process.env.VUE_APP_S3_ASSET_URL + "/import-sample/company_tree.csv",
        JobOpening:
          process.env.VUE_APP_S3_ASSET_URL + "/import-sample/vacancies.csv",
      },
    };
  },
  created() {
    if (!this.$can("import_delete")) {
      this.tableColumns = this.tableColumns.filter(
        (item) => item.key != "select"
      );
    }
  },
  watch: {},
  methods: {
    formSubmitted() {
      const self = this;
      this.isBusy = true;
      let data = {};
      data.url = "imports";
      data.params = {
        moduleFilter: this.moduleFilter,
        file: this.file,
      };
      this.$store
        .dispatch("app/store", data)
        .then((res) => {
          this.isBusy = false;
          this.refetchData();
          // this.$toast({
          //   component: ToastificationContent,
          //   props: {
          //     title: "Import Started",
          //     icon: "BellIcon",
          //     variant: "success",
          //     text: res.data.message,
          //   },
          // });

          this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Import Started',
                icon: 'BellIcon',
                variant: 'success',
                text: res.data.message,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 successful-info",
              hideProgressBar : true,
            });
        })
        .catch((error) => {
          this.isBusy = false;
          // this.$toast({
          //   component: ToastificationContent,
          //   props: {
          //     title: "Oops! Import Failed",
          //     icon: "BellIcon",
          //     variant: "danger",
          //     text: error,
          //   },
          // });
          this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Oops! Import Failed',
                icon: 'BellIcon',
                variant: 'danger',
                text: error,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 error-info ",
              hideProgressBar : true,
            });
        });
    },
    editRecord(data) {
      this.$router.push(`/edit/import/${data.item.hashid}`).catch(() => {});
    },
    viewRecord(data) {
      this.$router.push(`/view/import/${data.item.hashid}`).catch(() => {});
    },
    confirmDeleteRecord(data) {
      this.$swal({
        title: "Are you sure?",
        text: `You want to delete ${data.item.file_name}.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteRecord(data.item.hashid);
        }
      });
    },
    confirmDeleteMultipleRecords() {
      this.$swal({
        title: "Are you sure?",
        text: `You want to delete ${this.selectedImports.length} Import, This cannot be undone.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("app-imports/removeMultipleImports", this.selectedImports)
            .then((res) => {
              this.isDeleteMultipleCandChecked = false;
              this.selectedImports = [];
              if (res.data.success) {
                this.refetchData();
                // this.$toast({
                //   component: ToastificationContent,
                //   props: {
                //     title: "Deleted Successfully.",
                //     icon: "BellIcon",
                //     variant: "success",
                //     text: res.data.message,
                //   },
                // });
                this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Deleted Successfully.',
                icon: 'BellIcon',
                variant: 'success',
                text: res.data.message,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 successful-info",
              hideProgressBar : true,
            });
              } else {
                // this.$toast({
                //   component: ToastificationContent,
                //   props: {
                //     title: "Import Deletion failed.",
                //     icon: "BellIcon",
                //     variant: "danger",
                //     text: res.data.message,
                //   },
                // });
                this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Import Deletion failed.',
                icon: 'BellIcon',
                variant: 'danger',
                text: res.data.message,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 error-info ",
              hideProgressBar : true,
            });
              }
            })
            .catch((err) => console.log(err));
        }
      });
    },
    refetchImportsData() {},
    deleteRecord(id) {
      const self = this;
      this.$store
        .dispatch("app-imports/removeImport", id)
        .then((res) => {
          if (res.status == "204") {
            // self.$toast({
            //   component: ToastificationContent,
            //   props: {
            //     title: "Import Deleted",
            //     icon: "BellIcon",
            //     variant: "success",
            //     text: "Import Deleted Successfully.",
            //   },
            // });

            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Import Deleted',
                icon: 'BellIcon',
                variant: 'success',
                text: "Import Deleted Successfully.",
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 successful-info",
              hideProgressBar : true,
            });
          } else {
            // self.$toast({
            //   component: ToastificationContent,
            //   props: {
            //     title: "Import Deletion failed.",
            //     icon: "BellIcon",
            //     variant: "danger",
            //     text: res.data.message,
            //   },
            // });
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Import Deletion failed.',
                icon: 'BellIcon',
                variant: 'danger',
                text: res.data.message,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 error-info ",
              hideProgressBar : true,
            });
          }
          self.refetchData();
        })
        .catch((err) => {
          // self.$toast({
          //   component: ToastificationContent,
          //   props: {
          //     title: "Import Deletion failed.",
          //     icon: "BellIcon",
          //     variant: "danger",
          //   },
          // });
          this.$toast({
              component: ToastificationContent,
              props: {
                title: `Import Deletion failed.`,
                icon:'ErrorIcon',
                variant : 'danger',
                hideClose: true,
                
              },
                  },
                  {
              timeout : 3000,
              position : 'bottom-center',
              toastClassName:"error-info",
              hideProgressBar : true,
                  })
          console.error(err);
        });
    },
    openWindow(link) {
      if (link) {
        window.open(link);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
